import RoutingGuideTypes from './RoutingGuideTypes';

export const routingGuideSuccess = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_ROUTING_GUIDE_SUCCESS,
  };
};
export const getRoutingGuidelistClearReq = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_ROUTING_GUIDE_LIST_CLEAR_REQ,
  };
};
export const getRoutingGuidelist = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_ROUTING_GUIDE_LIST,
  };
};

export const getRoutingGuidelistReset = () => {
  return { type: RoutingGuideTypes.GET_ROUTING_GUIDE_DATA_RESET };
};

export const createRoutingGuideInProgress = (payload) => {
  return { payload, type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_PROGRESS };
};

export const createRoutingGuideInSuccess = (payload) => {
  return { payload, type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_SUCCESS };
};

export const createRoutingGuideInClear = () => {
  return { type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_CLEAR };
};

export const createRoutingGuideUserInProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_PROGRESS,
  };
};

export const createRoutingGuideUserInSuccess = (payload) => {
  return { payload, type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_SUCCESS };
};

export const createRoutingGuideUserInClear = () => {
  return { type: RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_CLEAR };
};

export const deleteRoutingGuidesInProgress = (payload) => {
  return { payload, type: RoutingGuideTypes.DELETE_ROUTING_GUIDES_PROGRESS };
};

export const deleteRoutingGuidesInSuccess = (payload) => {
  return { payload, type: RoutingGuideTypes.DELETE_ROUTING_GUIDES_SUCCESS };
};

export const deleteRoutingGuidesInError = (payload) => {
  return { payload, type: RoutingGuideTypes.DELETE_ROUTING_GUIDES_ERROR };
};

export const setSelectedRoutingGuides = (payload) => {
  return { payload, type: RoutingGuideTypes.SET_SELECTED_ROUTING_GUIDE };
};

export const setTransportData = (payload) => {
  return { payload, type: RoutingGuideTypes.SET_TRANSPORT_DATA };
};

export const getContentNXPRoutingGuideInProgress = () => {
  return { type: RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE };
};

export const getContentNXPRoutingGuideInSuccess = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE_SUCCESS,
  };
};

export const getContentNXPRoutingGuideInError = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE_ERROR,
  };
};

export const updateContentNXPRoutingGuideInProgress = (payload) => {
  return { payload, type: RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE };
};

export const updateContentNXPRoutingGuideInSuccess = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE_SUCCESS,
  };
};

export const updateContentNXPRoutingGuideInError = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE_ERROR,
  };
};

export const getNXPUserSearchInProgress = (payload) => {
  return { payload, type: RoutingGuideTypes.GET_NXP_USER_SEARCH_INPROGRESS };
};

export const getNXPUserSearchInInSuccess = (payload) => {
  return { payload, type: RoutingGuideTypes.GET_NXP_USER_SEARCH_SUCCESS };
};

export const getNXPUserSearchInInFail = (payload) => {
  return { payload, type: RoutingGuideTypes.GET_NXP_USER_SEARCH_FAIL };
};

export const getNXPUserSearchResetRequest = () => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SEARCH_RESET_REQUEST };
};

export const setNXPUserSelectedRecord = (payload) => {
  return { payload, type: RoutingGuideTypes.GET_NXP_USER_SELECTED_RECORD };
};

export const getNXPUserSearchInClearData = () => {
  return { type: RoutingGuideTypes.GET_NXP_USER_SEARCH_CLEAR_DATA };
};

export const deleteRoutingUserInProgress = (payload) => {
  return { payload, type: RoutingGuideTypes.DELETE_NXP_USER };
};

export const deleteRoutingUserInSuccess = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.DELETE_NXP_USER_SUCCESS,
  };
};

export const deleteRoutingUserInFail = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.DELETE_NXP_USER_FAIL,
  };
};

export const getNXPUserTypesDataHandler = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.NPX_USER_TYPES_DATA,
  };
};

export const clientCodeDataActionHandler = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.CLIENT_CODE_DATA,
  };
};

export const setRoutingGuideSearchParams = (payload) => ({
  payload,
  type: RoutingGuideTypes.SET_ROUTING_GUIDE_SEARCH_PARAMS,
});

export const resetRoutingGuideSearchParams = () => ({
  type: RoutingGuideTypes.RESET_ROUTING_GUIDE_SEARCH_PARAMS,
});

export const getFilteredGuideList = (payload) => ({
  payload,
  type: RoutingGuideTypes.GET_FILTERED_GUIDE_LIST,
});

export const setRoutingSpotFilterData = (payload) => ({
  payload,
  type: RoutingGuideTypes.SET_ROUTING_SPOT_FILTERED_DATA,
});

export const getRoutingGuideCarriersProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_PROGRESS,
  };
};

export const getRoutingGuideCollaboratorsProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_COLLABORATORS_ROUTING_GUIDE_PROGRESS,
  };
};

export const getRoutingGuideCarriersSuccess = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_SUCCESS,
  };
};

export const getRoutingGuideCollaboratorsSuccess = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_COLLABORATORS_ROUTING_GUIDE_SUCCESS,
  };
};

export const getAllUsersNameForGuidesSuccess = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_ALL_USERS_NAME_SUCCESS,
  };
};

export const getAllUsersNameForGuidesProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_ALL_USERS_NAME_PROGRESS,
  };
};

export const getRoutingGuideCarriersError = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_ERROR,
  };
};

export const editRoutingGuideCarrierProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.EDIT_CARRIER_ROUTING_GUIDE_PROGRESS,
  };
};

export const editRoutingGuideCollaboratorsProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.EDIT_COLLABORATORS_ROUTING_GUIDE_PROGRESS,
  };
};

export const editRoutingGuideCarrierError = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.EDIT_CARRIER_ROUTING_GUIDE_ERROR,
  };
};

export const addRoutingGuideCarrierProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_CARRIER_PROGRESS,
  };
};

export const addRoutingGuideCollaboratorsProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_COLLABORATORS_PROGRESS,
  };
};

export const addRoutingGuideCarrierError = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_CARRIER_ERROR,
  };
};

export const deleteRoutingGuideCollaboratorProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.DELETE_ROUTING_GUIDE_COLLABORATOR_PROGRESS,
  };
};

export const deleteRoutingGuideCarrierProgress = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.DELETE_ROUTING_GUIDE_CARRIER_PROGRESS,
  };
};

export const addRoutingGuideHeader = (payload) => {
  return {
    payload,
    type: RoutingGuideTypes.ADD_ROUTING_GUIDE_HEADER,
  };
};
